import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from '~/App';
import store from '~/utils/redux/store';
import { GlobalStyles, Loading } from './components/common';
import { LoadingProvider, WebSocketProvider } from './context';
import reportWebVitals from './reportWebVitals';
import './thirdParties/i18n';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GlobalStyles>
        <WebSocketProvider>
          <LoadingProvider>
            <Suspense fallback={<Loading />}>
              <App />
            </Suspense>
          </LoadingProvider>
        </WebSocketProvider>
      </GlobalStyles>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
